import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "underscore";
import styles from "./index.module.scss";
import { filterType } from "../../../../../utils/constants";
import { changeNumShow, initUrlParams, stringifySearch } from "../../../../../utils";
import { mpSearchData } from "../../../../../utils/mp_search_data";

const filterTypeArr = [
  {
    id: filterType.COMPREHENSIVE_SORT,
    name: "综合",
    clstag: mpSearchData.filter.comprehensive,
  },
  {
    id: filterType.SORT_TOTALSALES15_DESC,
    name: "销量",
    clstag: mpSearchData.filter.sale,
  },
  {
    id: filterType.SORT_COMMENTCOUNT_DESC,
    name: "评论数",
    clstag: mpSearchData.filter.comment,
  },
  {
    id: filterType.SORT_WINSDATE_DESC,
    name: "新品",
    clstag: mpSearchData.filter.winsdate,
  },
  {
    id: filterType.SORT_DREDISPRICE,
    name: "价格",
    clstag: mpSearchData.filter.price,
  },
];

function TopFilter() {
  const history = useHistory();
  const { pathname } = useLocation();
  const { allData, wordDesc, urlParams, totalItem } = useSelector((state) => state.searchReducer);
  const [lowPrice, setLowPrice] = useState("");
  const [highPrice, setHighPrice] = useState("");
  const [sort, setSort] = useState(filterType.COMPREHENSIVE_SORT);
  const [priceUp, setPriceUp] = useState(true); // 按照价格递增排列

  useEffect(() => {
    setLowPrice(urlParams.pM);
    setHighPrice(urlParams.pL);
    urlParams.sort
      ? setSort(
          filterType.SORT_DREDISPRICE.indexOf(urlParams.sort) !== -1
            ? filterType.SORT_DREDISPRICE
            : urlParams.sort
        )
      : setSort(filterType.COMPREHENSIVE_SORT);
  }, [urlParams]);

  const sortStyle = (id) => {
    let priceType;

    if (sort === id) {
      if (id === filterType.SORT_DREDISPRICE) {
        priceType = priceUp ? styles.up : styles.down;
      }

      return `${styles.curr} ${priceType}`;
    }
  };

  const handleSortClick = (sortId) => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody)
    setSort(sortId);
    if (sortId === filterType.SORT_DREDISPRICE) {
      setPriceUp(!priceUp);
      _searchParamsBody.sort = sortId.split("&")[priceUp ? 0 : 1];
    } else {
      _searchParamsBody.sort = sortId;
    }
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody),
    });
  };

  const handlePriceOk = () => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    if (!highPrice && !lowPrice) {
      delete _searchParamsBody.pL;
      delete _searchParamsBody.pM;
    } else if (lowPrice && !highPrice) {
      _searchParamsBody.pM = lowPrice;
      delete _searchParamsBody.pL;
    } else {
      _searchParamsBody.pM = Math.min(highPrice, lowPrice || 0);
      _searchParamsBody.pL = Math.max(highPrice, lowPrice || 0);
    }
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody),
    });
  };

  const handlePriceCancel = () => {
    setHighPrice("");
    setLowPrice("");
  };

  const handlePrevPage = () => {
    const { currPage } = allData;
    if (currPage === 1) return;
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody, true)
    _searchParamsBody.page = currPage - 1;
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody),
    });
  };

  const handleNextPage = () => {
    const { currPage, totalPage } = allData;
    if (currPage === totalPage) return;
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody, true)
    _searchParamsBody.page = currPage + 1;
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody),
    });
  };

  return (
    <div className={`${styles["f-line"]} ${styles.top}`}>
      <div className={styles["f-sort"]}>
        {filterTypeArr.map((item) => {
          return (
            <button
              key={item.id}
              className={sortStyle(item.id)}
              onClick={() => handleSortClick(item.id)}
              clstag={item.clstag}
            >
              {item.name}
              <i></i>
              <span
                className={item.name === "价格" ? `${styles["f-cut-price"]}` : styles["f-cut"]}
              ></span>
            </button>
          );
        })}
      </div>
      <div className={styles["price-chose"]}>
        <div className={styles["sl-price"]}>
          <input
            className={styles["input-txt"]}
            title="最低价"
            maxLength="6"
            placeholder="￥"
            value={lowPrice || ""}
            onChange={(e) => setLowPrice(e.target.value.replace(/[^0-9]/g, ""))}
          />
          <em> - </em>
          <input
            className={styles["input-txt"]}
            title="最高价"
            maxLength="8"
            placeholder="￥"
            value={highPrice || ""}
            onChange={(e) => setHighPrice(e.target.value.replace(/[^0-9]/g, ""))}
          />
        </div>
        <div className={styles["price-edit"]}>
          <span className={styles["price-cancle-btn"]} onClick={handlePriceCancel}>
            清空
          </span>
          <button className={`${styles.btn} ${styles["btn-default"]}`} onClick={handlePriceOk}>
            确定
          </button>
        </div>
      </div>

      <div id="J_topPage" className={styles["f-pager"]}>
        <span className={styles["fp-text"]}>
          <b>{allData.currPage || allData.totalPage === 0 ? allData.currPage : 0}</b>
          <em>/</em>
          <i>{allData.totalPage ? allData.totalPage : 0}</i>
        </span>
        <span
          className={`${styles["fp-prev"]} ${allData?.currPage <= 1 ? styles.disabled : null}`}
          onClick={handlePrevPage}
        >
          &lt;
        </span>
        <span
          className={`${styles["fp-next"]} ${
            allData?.currPage >= allData?.totalPage ? styles.disabled : null
          }`}
          onClick={handleNextPage}
        >
          &gt;
        </span>
      </div>

      <div className={styles["st-ext"]}>
        共&nbsp;<span>{changeNumShow(totalItem)}</span>个{wordDesc}
      </div>
    </div>
  );
}

export default TopFilter;
